import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (from 999_master_foxpro_schema.sql)
// ============================================================

export interface F90B {
  f90b_01: string;         // 申請單號 (PK, auto-generated)
  f90b_11: string;         // 申請部門
  f90b_12: string;         // 申請人
  f90b_13: string | null;  // 申請日期 (ISO string)
  f90b_91: string;         // 建立者ID
  f90b_92: string | null;  // 建立日期
  f90b_93: string;         // 建立時間
  f90b_20: number;         // 增補人數
  f90b_61: string;         // 審核狀態1
  f90b_62: string;         // 審核人1
  f90b_63: string | null;  // 審核日期1
  f90b_64: string;         // 審核意見1
  f90b_71: string;         // 審核狀態2
  f90b_72: string;         // 審核人2
  f90b_73: string | null;  // 審核日期2
  f90b_74: string;         // 審核意見2
  f90b_76: string;         // 審核狀態3
  f90b_77: string;         // 審核人3
  f90b_78: string | null;  // 審核日期3
  f90b_79: string;         // 審核意見3
  f90b_67: string;         // 審核人4
  f90b_68: string | null;  // 審核日期4
  f90b_69: string;         // 審核意見4
  f90b_80: string;         // 審核狀態5
  f90b_87: string;         // 審核人5
  f90b_88: string | null;  // 審核日期5

  // Association
  details?: F90B1[];
}

export interface F90B1 {
  f90b1_01: string;         // 申請單號 (FK)
  f90b1_02: number;         // 項次
  f90b1_11: string;         // 職稱代碼
  f90b1_11a: string;        // 職稱名稱
  f90b1_12: number;         // 編制人數
  f90b1_13: number;         // 現有人數
  f90b1_14: number;         // 申請人數
  f90b1_15: string | null;  // 需求日期
  f90b1_21: string;         // 增補原因
  f90b1_22: number;         // 性別
  f90b1_23: string;         // 年齡範圍
  f90b1_24: string;         // 學歷
  f90b1_25: string;         // 科系
  f90b1_26: string;         // 經歷
  f90b1_91: string;         // 建立者ID
  f90b1_92: string | null;  // 建立日期
  f90b1_93: string;         // 建立時間
  f90b1_27: string;         // 其他條件
  f90b1_281: boolean;       // flag 1
  f90b1_282: boolean;       // flag 2
  f90b1_32: string;         // 部門代碼
  f90b1_32a: string;        // 部門名稱
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW9201ListResponse {
  data: F90B[];
  total: number;
  page: number;
  size: number;
}

export interface PW9201CreateRequest {
  master: Partial<F90B>;
  details: Partial<F90B1>[];
}

// ============================================================
// API methods
// ============================================================

export const pw9201Api = {
  async list(page = 1, size = 20): Promise<PW9201ListResponse> {
    const res = await apiClient.get('/api/pw9201', { params: { page, size } });
    return res.data;
  },

  async search(keyword: string): Promise<PW9201ListResponse> {
    const res = await apiClient.get('/api/pw9201/search', { params: { keyword } });
    return res.data;
  },

  async get(id: string): Promise<F90B> {
    const res = await apiClient.get(`/api/pw9201/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: PW9201CreateRequest): Promise<F90B> {
    const res = await apiClient.post('/api/pw9201', data);
    return res.data;
  },

  async update(id: string, data: PW9201CreateRequest): Promise<F90B> {
    const res = await apiClient.put(`/api/pw9201/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pw9201/${encodeURIComponent(id)}`);
  },

  /** Lookup: department, employee */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9201/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
